export const diccionario = {
  es: {
    nom_equip:          "Nombre de equipo",
    clau:               "Clave",
    bienvenida:         "Bienvenido",
    comenzar:           "Empezar partida",
    idioma_label:       "Idioma",
    cargando:           "Cargando...",
    volver_home:        "Volver al inicio",
    equipo:             "Equipo",
    durada:             "Duración",
    pistas:             "Pistas",
    errores:            "Errores",
    penalizacion:       "Penalización",
    iniciar_invest:     "Iniciar investigación",
    continuar_invest:   "Continúa investigando",
    ranking:            "Ránquing",
    carga_ranking:      "Cargando ránking...", 
    tornar_invest:      "Volver a la investigación",
    error_invest:       "Error al establecer conexión con la central. No se ha podido obtener el detalle.",
    establint:          "Estableciendo comunicación con la central...",
    continuar_invest:   "No, queremos seguir investigando",
    volem_pista:        "¡Sí, la necesitamos!",
    seguent_pista:      "La siguiente pista sumará",
    minuts:             "minutos",
    voleu_pista:        "a vuestro tiempo. ¿Queréis obtener la pista?", 
    tornar:             "Volver al archivo del caso",
    solucio:            "Solución",
    incorrecta:         "La agencia está convencida de que esta no es la respuesta correcta. Continúa investigando.",
    instruccions:       "Instrucciones",
    chat:               "Chat no disponible",
    online:             "En línea",
    wrong:              "Respuesta incorrecta (+1 min). Inténtalo de nuevo.",
    veure_referencies:  "Ver referencias",
    ranquing:           "Ranking",
    referencies:        "Referencias literarias",
  },
  ca: {
    nom_equip:          "Nom d'equip",
    clau:               "Clau",
    bienvenida:         "Benvingut",
    comenzar:           "Començar partida",
    idioma_label:       "Idioma",
    cargando:           "Carregant...",
    volver_home:        "Tornem a home",
    equipo:             "Equip",
    durada:             "Durada",
    pistas:             "Pistes",
    errores:            "Errors",
    penalizacion:       "Penalització",
    iniciar_invest:     "Iniciar investigació",
    continuar_invest:   "Continua investigant",
    ranking:            "Rànquing",
    carga_ranking:      "Carregant rànquing...",
    tornar_invest:      "Tornar a la investigació",
    error_invest:       "Error establint connexió amb central. No s'ha pogut aconseguir el detall.",
    establint:          "Establint comunicació amb central...",
    continuar_invest:   "No, volem continuar investigant",
    volem_pista:        "Sí, la necessitem!",
    seguent_pista:      "La següent pista sumarà",
    minuts:             "minuts",
    voleu_pista:        "al vostre temps. Voleu obtenir la pista?",
    tornar:             "Tornar a l'arxiu del cas",
    solucio:            "Solució",
    incorrecta:         "L'agencia està segura de que aquesta no és la resposta correcta. Continua investigant.",
    instruccions:       "Instruccions",
    chat:               "Chat no disponible",
    online:             "En línia",
    wrong:              "Resposta incorrecta (+1 min). Torneu-ho a provar.",
    veure_referencies:  "Veure referències",
    ranquing:           "Rànquing",
    referencies:        "Referències literaries",
  },
  en: {
    nom_equip:          "Team Name",
    clau:               "Password",
    bienvenida:         "Welcome",
    comenzar:           "Start game",
    idioma_label:       "Language",
    cargando:           "Loading...",
    volver_home:        "Return home",
    equipo:             "Team",
    durada:             "Duration",
    pistas:             "Clues",
    errores:            "Errors",
    penalizacion:       "Penalty",
    iniciar_invest:     "Start investigation",
    continuar_invest:   "Keep investigating",
    ranking:            "Ranking",
    carga_ranking:      "Loading ranking...",
    tornar_invest:      "Return to investigation",
    error_invest:       "Error connecting to central. Could not retrieve the detail.",
    establint:          "Establishing communication with central...",
    continuar_invest:   "No, we want to continue investigating",
    volem_pista:        "Yes, we need it!",
    seguent_pista:      "The next clue will add",
    minuts:             "minutes",
    voleu_pista:        "at your time. Do you want to get the clue?",
    tornar:             "Return to the case file",
    solucio:            "Solution",
    incorrecta:         "The agency is convinced that this is not the correct answer. It continues to investigate.",
    instruccions:       "Instructions",
    chat:               "Chat not available",
    online:             "Online",
    wrong:              "Incorrect answer (+1 min). Try again.",
    veure_referencies:  "See references",
    ranquing:           "Ranking",
    referencies:        "Literary references",
  }
};